import CircularProgress from '@mui/material/CircularProgress'

export { PendingIcon }

type Props = {
  isPending: boolean
  icon: React.ReactElement
}

const PendingIcon = ({ isPending, icon }: Props) =>
  isPending ? <CircularProgress size={20} /> : icon
